"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */

const NotificationCounter = ({
  amount,
  persist,
  title
}) => {
  const amountDigits = amount?.toString()?.length;
  const notificationText = amount && amount > 999 ? '999+' : amount?.toString() || '0';
  const screenReaderText = amount && amount > 999 ? 'more than 999 notifications' : `${amount || 0} notifications`;
  return Boolean(amount || persist) ? (0, _jsxRuntime.jsx)("span", {
    css: theme => [_styles.styles.default(theme, amountDigits)],
    title: title,
    "aria-label": screenReaderText,
    role: "status",
    children: notificationText
  }) : null;
};
var _default = exports.default = NotificationCounter;